import React from 'react';
import styles from './Card.module.css';

const Card = ({
  children,
  title,
  subtitle,
  action,
  padding = 'md',
  className = '',
  ...props
}) => {
  return (
    <div className={`${styles.card} ${styles[padding]} ${className}`} {...props}>
      {(title || action) && (
        <div className={styles.header}>
          <div className={styles.titleContainer}>
            {title && <h3 className={styles.title}>{title}</h3>}
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          </div>
          {action && <div className={styles.action}>{action}</div>}
        </div>
      )}
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default Card;
